module.exports = __webpack_public_path__ + "static/prettier-fa5db0f913ead96c68af74fb42bbe362.png";